module.exports = "/images/play-and-repeat.svg?f5ae5a7335555eb60236145c34d75d7c";